<template>
  <v-row>
    <v-col
      v-if="canModify"
      cols="auto"
    >
      <v-btn
        class="mr-3"
        right
        color="success"
        @click="$emit('toggle-form')"
      >
        <v-icon>{{ isShowingForm ? "mdi-minus" : "mdi-plus" }}</v-icon>
      </v-btn>
    </v-col>

    <v-col
      v-if="canModify"
      cols="auto"
    >
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn
            class="white--text"
            :disabled="!hasSelectedCustomers"
            color="red"
            @click="$emit('delete-selected')"
            v-on="on"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t($ts.customer.deleteSelectedCustomers) }}</span>
      </v-tooltip>
    </v-col>

    <v-spacer />
    <v-col>
      <slot name="search" />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "CustomerActions",
})
export default class CustomerActions extends Vue {
  @Prop({ type: Boolean, required: true }) isShowingForm!: boolean;
  @Prop({ type: Boolean, required: true }) hasSelectedCustomers!: boolean;
  @Prop({ type: Boolean, required: true }) canModify!: boolean;
}
</script>
